import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAuth } from "../../Contexts/AuthContext"
import supabase from "../../utils/subabaseClient"

export default function useData() {
  const { login } = useAuth()
  const navigate = useNavigate()
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [loading, setLoading] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoading(true)
    try {
      const {
        data: { session },
        error,
      } = await supabase.auth.signInWithPassword({
        email,
        password,
      })
      if (error) {
        console.error("Error logging in user:", error.message)
      } else {
        console.log("User logged in successfully!")
        login({
          id: session?.user?.id,
          email: session?.user?.email,
          username: session?.user?.user_metadata?.username,
        })
        navigate("/")
      }
    } catch (error) {
      console.error("Error logging in user:", error)
    }
    setLoading(false)
  }

  return {
    email,
    setEmail,
    password,
    setPassword,
    handleSubmit,
    loading,
  }
}
